import React from "react"
import game from "domino.png"

const Domino = props => <img src={game} className="game" {...props} />

export default Domino
